import ResetPassword from './ResetPassword';
import authRoles from 'app/auth/authRoles';

const ResetPasswordConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          generalMenu: true,
          personalMenu: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/reset-password/:code',
      component: ResetPassword,
    },
  ],
};

export default ResetPasswordConfig;
